import BaseAction from './BaseAction.js';

class UpdateTrackVolumeAction extends BaseAction {
    constructor(sequencerEngine) {
        super(sequencerEngine);
    }

    execute({track, value}) {
        if (track && !isNaN(value)) {
            track.setVolume(value);
        }
    }
}

export default UpdateTrackVolumeAction;
